import { render, staticRenderFns } from "./DataDanGuChun.vue?vue&type=template&id=a0df6458&"
import script from "./DataDanGuChun.vue?vue&type=script&lang=js&"
export * from "./DataDanGuChun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports